import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMap}  from '@fortawesome/free-solid-svg-icons';
import {faLandmark}  from '@fortawesome/free-solid-svg-icons';
import {faTools}  from '@fortawesome/free-solid-svg-icons';
import {faCalculator}  from '@fortawesome/free-solid-svg-icons';
import {faBrush}  from '@fortawesome/free-solid-svg-icons';
import {faTasks}  from '@fortawesome/free-solid-svg-icons';
import {faChartBar}  from '@fortawesome/free-solid-svg-icons';
import {faProjectDiagram}  from '@fortawesome/free-solid-svg-icons';
import {faUsersCog}  from '@fortawesome/free-solid-svg-icons';
import {faPeopleArrows}  from '@fortawesome/free-solid-svg-icons';
import {faHouseUser}  from '@fortawesome/free-solid-svg-icons';
import {faCalendarCheck}  from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import ContactUs from './components/contactUs';


export default class services extends React.Component {
    constructor(props) {
        super(props);
      
    }

    render() {
        return (
            <div className="container-fluid rtl">
             <div className="row bg-alt">
                <div className="container ">
                    
                <h1 className="block-title text-center title  mt-5">
              خدمات هاد </h1>
              
             
                    <div className="row justify-content-center my-0">
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container ">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faMap} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        دراسة الجدوى والتخطيط الاستراتيجي
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faLandmark} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        التعقيب والخدمات الحكومية
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faBrush} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        الخدمات الإنشائية والديكور
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faTools} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        تجهيز المواد والمعدات
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faCalendarCheck} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        إدارة المنشأة ومتابعة نقاط القوة والضعف
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faChartBar} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        إعداد اللوائح التنظيمية والهياكل الإدارية والعقود والسياسات                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faProjectDiagram} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        إنشاء وتطوير الهيكل التنظيمي والأقسام الإدارية 
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faPeopleArrows} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        تطوير ومتابعة الجودة   
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="services-header">
                            <div className="circles-container">
                            <div className="services-icon-circle1"></div>
                            <div className="services-icon-circle2"></div>
                            <div className="services-icon-circle3">
                            <FontAwesomeIcon icon={faHouseUser} size="2x" className="services-icon "/>
                            </div>
                            </div>
                        </div>
                        <div className="services-body">
                        التدريب الداخلي 
                        </div>
                    </div>
                     {/*    <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container">
                        <FontAwesomeIcon icon={faMap} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9  services-content">
                         دراسة الجدوى والتخطيط الاستراتيجي
                        </div>
                    </div>
                        </div>

                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faLandmark} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        التعقيب والخدمات الحكومية
                        </div>
                    </div>
                        </div>
                        
                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container">
                        <FontAwesomeIcon icon={faBrush} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9  services-content">
                        الخدمات الإنشائية والديكور
                        </div>
                    </div>
                        </div>
                        
                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container">
                        <FontAwesomeIcon icon={faTools} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9  services-content">
                        تجهيز المواد والمعدات
                        </div>
                    </div>
                        </div>

                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faCalendarCheck} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        إدارة المنشأة ومتابعة نقاط القوة والضعف
                        </div>
                    </div>
                        </div>
                        
                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container">
                        <FontAwesomeIcon icon={faChartBar} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9  services-content">
                        إعداد اللوائح التنظيمية والهياكل الإدارية والعقود والسياسات
                        </div>
                    </div>
                        </div>

                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faCalculator} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                      التحليل المالي والمحاسبي
                        </div>
                    </div>
                        </div>
                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faTasks} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        إدارة المخزون وإدارة الطلبات 
                                           </div>
                    </div>
                        </div>
                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faUsersCog} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        إدارة الموارد البشرية
                        </div>
                    </div>
                        </div>

                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faProjectDiagram} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        إنشاء وتطوير الهيكل التنظيمي والأقسام الإدارية                    </div>
                    </div>
                        </div>

                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faPeopleArrows} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        تطوير ومتابعة الجودة                    </div>
                    </div>
                        </div>

                        <div className="col-md-3 mx-md-3">
                        <div className="row services-container">
                        <div className="col-3 services-icon-container ">
                        <FontAwesomeIcon icon={faHouseUser} size="3x" className="services-icon"/>
                        </div>
                        <div className="col-9 services-content">
                        التدريب الداخلي                    </div>
                    </div>
                        </div> */}

                        </div>
                        </div>
                        </div>
                        <div className="row">
                       <div className="wave-container ">
                <svg viewBox="0 50 500 500" preserveAspectRatio="xMinYMin meet" className="wave-svg">
                <path d="M0,100 C150,200 350,0 500,100 L500,50 L0,50 Z" 
                    className="wave-path"></path>
                </svg>
                {/* <img src="https://i.ibb.co/BLMjxpN/Logo-Circle.png" className="img-fluid haad-circle"/> */}
                {/* <img src="https://i.ibb.co/zSqwVYk/arrow-Down.png" className="img-fluid haad-arrow hvr-hang"/> */}
                <img src="https://i.ibb.co/wy7sF34/Haa-Gray-copy.png" className="img-fluid "/>
               </div>
               
                       </div>
                       <div className="container">

                     <div className="row mb-5">
                     <div className="col-12 col-md-6 justify-content-center align-self-center">
                       <h1 className="block-title text-center title">
              تواصل معنا </h1>
                       </div>
                       
                      
              <div className="col-12 col-md-6 " id="contactus">
              

                <ContactUs/>
                  
            </div>
                     </div>
                       </div>
                    
           
                  
                
            </div>
        );
    }


}
